import ExcelJS from 'exceljs/dist/exceljs.min.js';

export const generateCode = (length) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};

export const handleDownloadExcel = async (
  dataSource,
  sheetName,
  fileName,
  headerOrder = { header: [] }
) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(sheetName);
  const orderedHeaders = headerOrder?.header || [];
  const headers = orderedHeaders.length > 0 ? orderedHeaders : Object.keys(dataSource?.[0] || {});

  worksheet.columns = headers.map((header) => ({
    header,
    key: header,
  }));
  worksheet.addRows(dataSource);

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = `${fileName}.xlsx`;
  link.click();
  URL.revokeObjectURL(url);
};
